import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ShareableLinkDocumentsHeading from './components/ShareableLinkDocumentsHeading';
import ShareableLinkDocumentsList from './components/ShareableLinkDocumentsList';
import ShareableLinkDocumentsProvider from '../../providers/ShareableLinkDocuments';
import ShareableLinkPath from './components/ShareableLinkPath';

import './ShareableLinkDocuments.styles.scss';
import './ShareableLinkDocuments.styles.responsive.scss';

type ShareableLinkDocumentsProps = {
  className?: string;
};

const ShareableLinkDocuments: React.FC<ShareableLinkDocumentsProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('shareable-link-documents', 'page', className);

  const { t } = useTranslation();

  return (
    <ShareableLinkDocumentsProvider>
      <div className={classes}>
        <h2>{t('files')}</h2>

        <div className="shareable-link-documents__content white-panel">
          <ShareableLinkPath />
          <ShareableLinkDocumentsHeading />
          <ShareableLinkDocumentsList />
        </div>
      </div>
    </ShareableLinkDocumentsProvider>
  );
};

export default ShareableLinkDocuments;
